import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Select,
  Form,
  message,
  Input,
  Button,
  notification,
  Modal,
  Tooltip, Upload
} from "antd";
import {CopyOutlined, PlusOutlined, QuestionCircleOutlined, UploadOutlined} from "@ant-design/icons";
import config from "../../util/ApiforContext";
import Screen from "../../util/Extensions/Screens";
import SweetAlert from "react-bootstrap-sweetalert";
import RequestHandler from "../../util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TransactionBankInfoAddForm = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pdfAlertVisible, setPdfAlertVisible] = useState(false);
  const [bankDropdown, setbankDropdown] = useState({
    data: [],
    loading: true,
  });
  const [bankBranchDropdown, setbankBranchDropdown] = useState({
    data: [],
    loading: true,
  });
  const [currencyDropdown, setCurrencyDropdown] = useState({
    data: [],
    loading: true,
  });
  const [activeBankId, setActiveBankId] = useState(0);
  const [activeVersion, setActiveVersion] = useState(0);
  const [callbackUrl, setCallbackUrl] = useState();

  const [bankRequirements, setBankRequirements] = useState({});
  const [useKeyBanks, setUseKeyBanks] = useState([134]);
  const [keyModalVisible, setKeyModalVisible] = useState(false);

  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    getBankDropdownData();
    getCurrencyDropdownData();
  }, []);

  useEffect(() => {
    if (activeVersion == 62001) {
      getGarantiCallbackUrl();
    } else {
      setCallbackUrl();
    }
  }, [activeVersion]);

  useEffect(() => {
    if (props.demoInformation) {
      welcome();
    }
    if (
      bankRequirements.isRequiredAccountInfo &&
      bankRequirements.isBankBranchIdRequired
    ) {
      getBankBranchDropdownData();
    }
  }, [bankRequirements]);

  const onFinish = (values) => {

    const formData = new FormData();


    for (const key in values) {
      if(key !== 'cerFile' && key !== "keyFile") {
        formData.append(key, values[key]);
      }
    }

    if (values.cerFile) {
      formData.append("cerFile", values.cerFile.fileList[0].originFileObj);
    }

    if (values.keyFile) {
      formData.append("keyFile", values.keyFile.fileList[0].originFileObj);
    }

    RequestHandler.post(`/TransactionBankInfo/AddWithBankCheck`, formData).then(
      (res) => {
        setLoading(false);
        if (res.success) {
          form.resetFields();
          getBankDropdownData();

          if (props.onSuccess) props.onSuccess();
        }
      }
    );
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onCancelPdfAlert = () => {
    setPdfAlertVisible(false);
    if (useKeyBanks.includes(activeBankId)) {
      setKeyModalVisible(true);
    }
  };
  const onConfirmPdfAlert = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);
    setTimeout(hide, 2500);

    const pdfEndPoint = `/Pdf/DownloadPdfByBankId?id=${activeBankId}&screenOption=${Screen.screen
      }&t=${RequestHandler.getToken()}`;

    RequestHandler.get(pdfEndPoint).then((res) => {
      window.open(config.apiUrl + pdfEndPoint);
      setPdfAlertVisible(false);
      notifyPdfDownloadSuccess();
    });
  };

  const notifyPdfDownloadSuccess = () => {
    notification.success({
      message: "BAŞARILI",
      description: "Pdf indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const getBankInfoRequirements = (bankId, version) => {
    RequestHandler.get(
      `/Bank/GetBankColumnsByBankId/${bankId}/${version}`
    ).then((response) => {
      setBankRequirements({
        isRequiredAccountInfo: response.isRequiredAccountInfo,
        ...response.bankInfoRequiredColumns,
        ...response.bankInfoAccountRequiredColumns,
        versions: response.versions,
      });
    });
  };

  const getGarantiCallbackUrl = () => {
    RequestHandler.get(`/TransactionBankInfo/GarantiApiCallbackUrl`).then(
      (response) => {
        setCallbackUrl(response.data);
      }
    );
  };

  const onActiveBankChange = (bankId) => {
    setActiveBankId(bankId);
    setActiveVersion(0);
    form.setFieldsValue({ version: 0 });

    getBankInfoRequirements(bankId, 0);

    setPdfAlertVisible(true);
  };

  const onActiveVersionChange = (version) => {
    setActiveVersion(version);
    getBankInfoRequirements(activeBankId, version);
  };

  const getBankDropdownData = () => {
    setbankDropdown({
      ...bankDropdown,
      loading: true,
    });

    RequestHandler.get(`/Bank/GetBankDropdown`).then((response) => {
      setbankDropdown({
        data: response.filter((x) => x.id !== 999),
        loading: false,
      });
    });
  };
  function welcome() {
    Modal.confirm({
      title: "Merhaba",
      content:
        "Banka hesabı tanımlaması yaptığınız takdirde demo kayıtlarınız silinecektir.",
      okText: "Anladım",
      keyboard: false,
      cancelButtonProps: { hidden: true },
    });
  }
  const getBankBranchDropdownData = () => {
    setbankBranchDropdown({
      ...bankBranchDropdown,
      loading: true,
    });

    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${activeBankId}`).then(
      (response) => {
        setbankBranchDropdown({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getCurrencyDropdownData = () => {
    setCurrencyDropdown({
      ...currencyDropdown,
      loading: true,
    });

    RequestHandler.get(`/Currency`).then((response) => {
      setCurrencyDropdown({
        data: response.value,
        loading: false,
      });
    });
  };

  const downloadKeyFile = () => {
    window.open(
      `${config.apiUrl
      }/TenantKeyFile/DownloadPublicKey/AccountTransaction/${activeBankId}?t=${RequestHandler.getToken()}`
    );
  };

  const FormItemLabelWithTooltip = ({ label, tooltip }) => {
    return (
      <>
        {label}{" "}
        <Tooltip title={
          <span>
            {tooltip?.split('*').filter(part => part.trim() !== '').map((line, index) => (
              <div key={index}> * {line}</div>
            ))}
          </span>
        } overlayStyle={{ maxWidth: "450px" }}>
          <QuestionCircleOutlined
            className="gx-text-blue"
            style={{ marginLeft: 5,marginRight:3, fontSize: "120%" }}
          />
        </Tooltip>
      </>
    );
  };

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="addForm"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Form.Item label="Banka" name="bankId" rules={[{ required: true }]}>
              <Select
                showSearch
                placeholder="Banka Seçiniz"
                optionFilterProp="children"
                onChange={onActiveBankChange}
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={bankDropdown.loading}
              >
                {bankDropdown.data.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {bankRequirements.versions?.length > 1 && (
              <Form.Item
                label="Versiyon"
                name="version"
                initialValue={activeVersion}
              >
                <Select
                  placeholder="Seçiniz"
                  value={activeVersion}
                  onChange={onActiveVersionChange}
                >
                  {bankRequirements.versions.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            {bankRequirements.isUserNameRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.userNameLabel ?? "Kullanıcı Adı"}
                    tooltip={bankRequirements.userNameInfo}
                  />
                }
                name="userName"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.userNameLabel?.trim() ?? "kullanıcı adı").toLowerCase()} alanını boş bırakmayın.`,
                }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isUserCodeRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.userCodeLabel ?? "Kullanıcı Kodu"}
                    tooltip={bankRequirements.userCodeInfo}
                  />
                }
                name="userCode"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.userCodeLabel?.trim() ?? "kullanıcı kodu").toLowerCase()} alanını boş bırakmayın.`,
                }]}              
                >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isPasswordRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.passwordLabel ?? "Şifre"}
                    tooltip={bankRequirements.passwordInfo}
                  />
                }
                name="password"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.passwordLabel?.trim() ?? "şifre").toLowerCase()} alanını boş bırakmayın.`,
                }]}                
                >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isCustomerNumberRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.customerNumberLabel ?? "Müşteri Numarası"}
                    tooltip={bankRequirements.customerNumberInfo}
                  />
                }
                name="customerNumber"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.customerNumberLabel?.trim() ?? "müşteri numarası").toLowerCase()} alanını boş bırakmayın.`,
                }]}                   
                >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isCorporateCodeRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.corporateCodeLabel ?? "Kurum Kodu"}
                    tooltip={bankRequirements.corporateCodeInfo}
                  />
                }
                name="corporateCode"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.corporateCodeLabel?.trim() ?? "kurum kodu").toLowerCase()} alanını boş bırakmayın.`,
                }]}                     
                >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isServiceUrlRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.serviceUrlLabel ?? "Url"}
                    tooltip={bankRequirements.serviceUrlInfo}
                  />
                }
                name="serviceUrl"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.serviceUrlLabel?.trim() ?? "url").toLowerCase()} alanını boş bırakmayın.`,
                }]}    
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isFirmNameRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.firmNameLabel ?? "Firma Adı"}
                    tooltip={bankRequirements.firmNameInfo}
                  />
                }
                name="firmName"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.firmNameLabel?.trim() ?? "firma adı").toLowerCase()} alanını boş bırakmayın.`,
                }]}
              >
                <Input />
              </Form.Item>
            )}

            {bankRequirements.isFirmKeyRequired && (
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label={bankRequirements.firmKeyLabel ?? "Firma Anahtarı"}
                    tooltip={bankRequirements.firmKeyInfo}
                  />
                }
                name="firmKey"
                rules={[{ 
                  required: true, 
                  whitespace: true,
                  message: `Lütfen ${(bankRequirements.firmKeyLabel?.trim() ?? "firma anahtarı").toLowerCase()} alanını boş bırakmayın.`,
                }]}
              >
                <Input />
              </Form.Item>
            )}

            {callbackUrl && (
              <Form.Item
                label="Tanımlanacak Callback Url"
                name="callbackUrl"
                initialValue={callbackUrl}
              >
                <Input.Group compact>
                  <Input
                    readOnly
                    value={callbackUrl}
                    style={{ width: "calc(100% - 36px)" }}
                  />
                  <Tooltip title="Kopyala">
                    <Button
                      icon={<CopyOutlined />}
                      onClick={() => navigator.clipboard.writeText(callbackUrl)}
                    />
                  </Tooltip>
                </Input.Group>
              </Form.Item>
            )}

            {bankRequirements.isRequiredAccountInfo ? (
              <>
                {bankRequirements.isBankBranchIdRequired && (
                  <Form.Item
                    label={
                      <FormItemLabelWithTooltip
                        label={"Şube Kodu"}
                        tooltip={bankRequirements.bankBranchIdInfo}
                      />
                    }
                    name="bankBranchId"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen şube kodu alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Şube seçiniz"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={bankBranchDropdown.loading}
                    >
                      {bankBranchDropdown.data.map((item) => (
                        <Select.Option key={item.id}>{item.name}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {bankRequirements.isAccountNumberRequired && (
                  <Form.Item
                    label={
                      <FormItemLabelWithTooltip
                        label={"Hesap Numarası"}
                        tooltip={bankRequirements.accountNumberInfo}
                      />
                    }
                    name="accountNumber"
                    rules={[
                      {
                        required: true,
                        message:
                          "Lütfen hesap numarası alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input maxLength="17" />
                  </Form.Item>
                )}

                {bankRequirements.isIbanRequired && (
                  <Form.Item
                    label={
                      <FormItemLabelWithTooltip
                        label={"Iban/Hesap No"}
                        tooltip={bankRequirements.ibanInfo}
                      />
                    }
                    name="iban"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen Iban/Hesap No alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input type="text" maxLength="26" />
                  </Form.Item>
                )}

                {bankRequirements.isAccountSuffixRequired && (
                  <Form.Item
                    label={
                      <FormItemLabelWithTooltip
                        label={"Hesap Ek Numarası"}
                        tooltip={bankRequirements.accountSuffixInfo}
                      />
                    }
                    name="accountSuffix"
                    rules={[
                      {
                        required: true,
                        message:
                          "Lütfen hesap ek numarası alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Input maxLength="4" />
                  </Form.Item>
                )}

                {bankRequirements.isCurrencyIdRequired && (
                  <Form.Item
                    label={
                      <FormItemLabelWithTooltip
                        label={"Döviz Kodu"}
                        tooltip={bankRequirements.currencyIdInfo}
                      />
                    }
                    name="currencyId"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen döviz kodu alanını boş bırakmayın.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Para birimini seçiniz"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencyDropdown.loading}
                    >
                      {currencyDropdown.data.map((item) => (
                        <Select.Option key={item.id}>
                          {item.code + " (" + item.symbol + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </>
            ) : null}

            {bankRequirements.isUsePfx && (
              <>
                <Form.Item   label={
                  <FormItemLabelWithTooltip
                    label=".cer Uzantılı Dosya"
                    tooltip="*Zorunlu Alanlar * Banka tarafından gönderilen .cer uzantılı dosya yüklenmelidir. *.cer uzantılı dosya tarafınıza iletilmediyse bankanız ile iletişime geçiniz. "
                  />
                } name="cerFile" rules={[
                  {
                    required: true,
                    message: "Banka tarafından gönderilen .cer uzantılı dosyanın yüklenmesi gerekmektedir.",
                  },
                ]}>
                  <Upload beforeUpload={() => false} accept=".cer">
                    <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                  </Upload>
                </Form.Item>

                <Form.Item  label={
                  <FormItemLabelWithTooltip
                    label=".key Uzantılı Dosya"
                    tooltip="*Zorunlu Alanlar * Banka tarafından gönderilen .key uzantılı dosya yüklenmelidir. *.key uzantılı dosya tarafınıza iletilmediyse bankanız ile iletişime geçiniz. "
                  />
                } name="keyFile" rules={[
                  {
                    required: true,
                    message: "Banka tarafından gönderilen .key uzantılı dosyanın yüklenmesi gerekmektedir.",
                  },
                ]}>
                  <Upload beforeUpload={() => false} accept=".key">
                    <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                  </Upload>
                </Form.Item>
              </>
            )}


            <Col style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
      <SweetAlert
        show={pdfAlertVisible}
        showCancel
        confirmBtnText={"Hayır"}
        cancelBtnText={"Evet"}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        title={"Uyarı"}
        onConfirm={onConfirmPdfAlert}
        onCancel={onCancelPdfAlert}
      >
        Erişim Bilgilerinizi Bankanızdan Aldınız mı?
      </SweetAlert>
      <Modal
        title="Sertfika Dosyası"
        visible={keyModalVisible}
        onOk={() => {
          setKeyModalVisible(false);
        }}
        onCancel={() => {
          setKeyModalVisible(false);
        }}
        centered={true}
        keyboard={true}
        width={500}
      >
        <p>
          Banka entegrasyon sürecinizin tamamlanabilmesi için sertfika dosyasını
          banka sistemine yüklemeniz gerekmektedir.
        </p>
        <p>
          Sertfika dosyasını{" "}
          <span
            onClick={downloadKeyFile}
            style={{ color: "blue", cursor: "pointer" }}
          >
            buradan{" "}
          </span>
          indirebilirsiniz
        </p>
        <p>
          Herhangi bir sorunla karşılaşırsanız, lütfen teknik destek ekibimizle
          iletişime geçin.
        </p>
      </Modal>
    </>
  );
};
export default TransactionBankInfoAddForm;
